import routes from 'global/Constants/routes';
import { FC } from 'react';
import packageJson from '../../../../package.json';
import TcLink from '../Link/TcLink';

const Footer: FC = () => {
  // const enamadId = '70645844';
  return (
    <div className=''>
      <div className='px-4 pt-6 pb-2 border-t bg-t-bg-color border-t-border-color-base'>
        <div className='flex flex-col items-center gap-4 sm:flex-row sm:justify-between'>
          <div>
            <TcLink link={routes.home.path} className=' hover:underline'>
              <h4 className='mb-1 text-xl font-bold text-center text-t-primary-color sm:text-right'>ای تیپاکس - eTipax</h4>
            </TcLink>
            <p className='w-full text-xs max-w-[300px] text-center sm:text-right'>
              سامانه ارسال بسته به سراسر کشور توسط تیپاکس مختص کسب و کار ها. ارسال همزمان چند مرسوله با مبدا و مقصد های مختلف، ثبت سفارش از طریق API, رصد و پیگیری مرسوله ها، مدیریت
              مالی سفارش ها
            </p>
          </div>
          <div className=''>
            <span className='block text-sm text-t-secondary-text-color'>دسترسی سریع</span>
            <ul className='flex flex-col items-center xl:gap-5 xl:flex-row sm:items-start'>
              <TcLink link={routes.aboutUs.path} className=' hover:underline'>
                <li className='font-medium'>درباره ما</li>
              </TcLink>
              <TcLink link={routes.contactUs.path} className=' hover:underline'>
                <li className='font-medium'>ارتباط با ما</li>
              </TcLink>
              <TcLink link={routes.dashboard.path} className=' hover:underline'>
                <li className='font-medium'>داشبورد</li>
              </TcLink>
              <TcLink link={routes.productTerm.path} className=' hover:underline'>
                <li className='font-medium'>لیست ممنوعات</li>
              </TcLink>
              <TcLink link={routes.footerTermsAndCondition.path} className=' hover:underline'>
                <li className='font-medium'>قوانین و ضوابط</li>
              </TcLink>
            </ul>
          </div>

          {/* Please note that we should disabled eslint for enamad link because eslint will noticed you rapidly for target blank with your source url but enamad wants to track its link's traffic to know our website*/}
          <div className='overflow-hidden border rounded-md shadow-md border-t-border-color-base'>
            {/* eslint-disable-next-line react/jsx-no-target-blank */}
            <a
              className='flex items-center justify-center p-2 mr-2 rounded cursor-pointer lg:p-4'
              target='_blank'
              referrerPolicy='origin'
              // href={`https://trustseal.enamad.ir/?id=${enamadId}`}>
              href='https://trustseal.enamad.ir/?id=212955&Code=cdCdps1StAf9sQN75zpP'>
              <div style={{ width: '75px', height: '75px', lineHeight: '0' }}>
                <img
                  referrerPolicy='origin'
                  id='enamad-logo'
                  className='inline-block w-full'
                  // src='/enamad.png'
                  src='https://trustseal.enamad.ir/logo.aspx?id=212955&Code=cdCdps1StAf9sQN75zpP'
                  width='75'
                  height='75'
                  alt='نماد اعتماد الکترونیک'
                  title=''
                  // style={{ objectFit: 'contain' }}
                  style={{ cursor: 'pointer' }}
                />
              </div>
            </a>
          </div>
        </div>
        <div className='flex flex-col items-center justify-between pt-6 sm:flex-row'>
          <span className='text-xs text-t-secondary-text-color'>تمامی حقوق این سایت متعلق به شرکت تیپاکس می باشد.</span>
          <div>
            <span className='text-xs text-t-text-color'>نسخه : {packageJson.version}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Footer;
